// extracted by mini-css-extract-plugin
module.exports = {"illustration":"CronJobDetailsModal_illustration__1V5HB","executionLoader":"CronJobDetailsModal_executionLoader__2lTQ7"};